import $http from '@axios'

export default {
  namespaced: true,
  state: {
    formPayload: {
      name: '',
      description: '',
      logo: '',
    },
    item_id: null
  },
  getters: {},
  mutations: {
    setFormPayload(state, value) {
      state.formPayload = value
    },
    setItemId(state, value) {
      state.item_id = value
    }
  },
  actions: {
    getData(context, { params }) {
      return new Promise((resolve, reject) => {
        $http.get('/item', { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    getDetail(context, { params, uuid }) {
      return new Promise((resolve, reject) => {
        $http.get(`/item/${uuid || ''}`, { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    postData(context, { payload, query }) {
      return new Promise((resolve, reject) => {
        $http.post(`/item${query || ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteData(context, query) {
      return new Promise((resolve, reject) => {
        $http.delete(`/item${query || ''}`)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
  },
}
